export default "__VITE_ASSET__1be3666d__"